<template>
	<div class="app-radio-button">
		<v-radio-group v-model="localValue" mandatory dense>
			<v-radio
				v-for="(item, i) in choices"
				:key="i"
				:label="item.title"
				:value="item.value"
				hide-details
				dense
				on-icon="mdi-radiobox-marked"
				off-icon="mdi-radiobox-blank"
				color="#1682D3"
				v-bind="$attrs"
				v-on="$listeners"
				:ripple="false"
				:disabled="item.disabled"
			>
				<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="{ ...scope, item }" /></template> -->
			</v-radio>
		</v-radio-group>
	</div>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
export default {
	name: 'AppRadioButton',
	mixins: [VModelMixin],
	props: {
		choices: { type: Array },
	},
};
</script>

<style scoped lang="scss">
.app-checkbox {
}
::v-deep {
	.v-icon {
		font-size: 16px !important;
	}
	.v-input--selection-controls__input {
		margin-top: -2px;
		margin-right: 0px !important;
	}
}
</style>
